import {useMemo} from "react";
import {useTranslation} from "react-i18next";

interface Props {
  prescriptionRequired?: number;
  herbal?: number;
  homeopathic?: number;
  display?: "list" | "block";
}

export const ProductTags = ({herbal, prescriptionRequired, homeopathic}: Props) => {
  const {t} = useTranslation();
  useMemo(() => {
    return prescriptionRequired === 1 || herbal === 1 || homeopathic === 1;
  }, [prescriptionRequired, herbal, homeopathic]);
  return (
    <div className="product-card__tags">
      <div className="tags-wrapper" role="list" aria-label={t('search.hits.productCard.tags') as string}>
        {prescriptionRequired === 1 && (
          <div className="tag" role="listitem">{t("search.hits.tags.prescriptionRequired")}</div>
        )}
        {herbal === 1 && (
          <div className="tag" role="listitem">{t("search.hits.tags.herbal")}</div>
        )}
        {homeopathic === 1 && (
          <div className="tag" role="listitem">{t("search.hits.tags.homeopathic")}</div>
        )}
      </div>
    </div>
  );
};
